import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestFindDataMemberDto, RequestSendReinvitationDto } from "../../../../bloc/hr/invite-member/invite-member.bloc";
import { NestApiProvider, FormDataUpload } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import { RequestUpdateEmpInviteMember } from "../dto/employees.dto";

@Injectable()
export class InvitationMemberNestApi {
    private service: string = '';
    private model: string = 'InvitationMembers';
    constructor(
        private nestApiProvider: NestApiProvider
    ) {

    }

    public findDataMember(payload: RequestFindDataMemberDto): Observable<any> {
        const method: string = 'GET';
        const func: string = 'findDataMember';
        const params: any = {};
        const urlParams: any = payload;
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }

    public sendReinvitation(payload: RequestSendReinvitationDto): Observable<any> {
        const method: string = 'POST';
        const func: string = 'sendReinvitation';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }

    public uploadEmployeeInviteMember(file: File, fileName: string): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'uploadEmployeeInviteMember';
        const params: FormDataUpload[] = [];
        params.push({ name: 'file', value: file, fileName });
        const urlParams: any = {};
    
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestUpload<ResponseData<any>>(method, url, params);
    }

    public updateEmployeeInviteMember(payload: RequestUpdateEmpInviteMember): Observable<any> {
        const method: string = 'POST';
        const func: string = 'updateEmployeeInviteMember';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/invitation-member.ts